// Dispatches a custom event for modern browsers.
export default (element, type, dictionary = {}) => {
  element.dispatchEvent(new CustomEvent(type, dictionary));
};
